import { configureStore, createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";

const defaultUserDataState = {
  personalInfo: [],
  loginData: [],
  renewPapersData: [],
  plateNumber: "",
  resetEmail: "",
  customerPeriodEnd: null,
  makeModelMapping: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
};

let userDataSlice = createSlice({
  name: "User Data",
  initialState: defaultUserDataState,
  reducers: {
    getLoginDetails(state, action) {
      const payload = action.payload;
      state.loginData = payload;
    },

    getResetEmail(state, action) {
      const payload = action.payload;
      state.resetEmail = payload;
    },

    setCustomerPeriodEnd(state, action) {
      const payload = action.payload;
      state.customerPeriodEnd = payload;
    },

    setUserPlateNumber(state, action) {
      const payload = action.payload;
      state.plateNumber = payload;
    },

    generalUserData(state, action) {
      const payload = action.payload;
      state.personalInfo = payload;
    },
    getRenewPapersData(state, action) {
      const payload = action.payload;
      state.renewPapersData = payload;
    },
    setMakeModelMappingLoading(state, action) {
      state.makeModelMapping.loading = action.payload;
    },
    setMakeModelMappingData(state, action) {
      state.makeModelMapping.data = action.payload;
      state.makeModelMapping.loading = false;
      state.makeModelMapping.error = null;
      state.makeModelMapping.lastFetched = new Date().toISOString();
    },
    setMakeModelMappingError(state, action) {
      state.makeModelMapping.error = action.payload;
      state.makeModelMapping.loading = false;
    },
    logout(state) {
      state.personalInfo = [];
      state.loginData = [];
      state.renewPapersData = [];
    },
  },
});

const persistConfig = {
  key: "agentProUserDetails",
  storage,
};

const persistedReducer = persistReducer(persistConfig, userDataSlice.reducer);

const store = configureStore({
  reducer: {
    userData: persistedReducer,
  },
  middleware: [thunk],
});

export const userDataActions = userDataSlice.actions;
export default store;
